import { formatMessage } from "lib/globalize-util";
import * as React from "react";

type SelectedElementsMessageProps = {
    size: number;
    selectedOptionsSize: number;
};

export const SelectedElementsMessage: React.FC<SelectedElementsMessageProps> = ({ size, selectedOptionsSize }) =>
    size === selectedOptionsSize
        ? formatMessage("Showing all values")
        : formatMessage("Showing |x| of |y| values", { x: selectedOptionsSize, y: size });
